// frontend/srs/api/apiClient.js
import axios from 'axios';

/**
 * Tell Axios how Django names its CSRF cookie.
 * Django stores the CSRF token in a cookie called "csrftoken".
 */
axios.defaults.xsrfCookieName = 'csrftoken';

/**
 * Tell Axios which HTTP header Django expects for CSRF protection.
 * Django looks for the token in the "X-CSRFToken" header.
 */
axios.defaults.xsrfHeaderName = 'X-CSRFToken';

/**
 * Create a reusable Axios instance for talking to Django.
 * This is the equivalent of a configured fetch() wrapper.
 */
const apiClient = axios.create({
  /**
   * Base URL of the backend.
   * '/' means "same origin" (same domain and port as the frontend).
   */
  baseURL: '/',

  /**
   * CRITICAL for Django sessions.
   * This ensures cookies (sessionid, csrftoken) are:
   *  - sent with every request
   *  - accepted from responses
   */
  withCredentials: true,

  /**
   * Default headers sent with every request.
   * DRF expects JSON by default.
   */
  headers: {
    'Content-Type': 'application/json',
  },
});

/**
 * Export the configured client so the entire app
 * uses the same auth + CSRF + session behavior.
 */
export default apiClient;
